export default __webpack_public_path__ + "31a27352f75ef6ebbd53035572629d3c.png";